import {
    LISTAR_CATLABORATORIOS
} from '../../types'


export default (state, action) => {
    switch (action.type){
        case LISTAR_CATLABORATORIOS:
            return{
                ...state,
                catLaboratorios: action.payload
            };
        default:
            return state
    }
        
}